import React, { useRef, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

const LanesButtons = props => {
    return (
        <ButtonGroup color="primary" aria-label="outlined primary button group">
            <Button><img src={require('../../../assets/icons/lane_config/8.svg')} onClick={()=>props.handleSetLane('8', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/7.svg')} onClick={()=>props.handleSetLane('7', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/6.svg')} onClick={()=>props.handleSetLane('6', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/5.svg')} onClick={()=>props.handleSetLane('5', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/3.svg')} onClick={()=>props.handleSetLane('3', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/4.svg')} onClick={()=>props.handleSetLane('4', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/2.svg')} onClick={()=>props.handleSetLane('2', props.direction)} /></Button>
            <Button><img src={require('../../../assets/icons/lane_config/1.svg')} onClick={()=>props.handleSetLane('1', props.direction)} /></Button>
        </ButtonGroup>
      )
}
export default LanesButtons;